import { Component, OnInit, Input, ViewChild } from '@angular/core';
import {DialogRef} from '@progress/kendo-angular-dialog';
import { FormGroup, FormBuilder, AbstractControl } from '@angular/forms';
import { FormService } from '../../../fw/services/form.service';
import { ValidationMessageComponent } from '../../shared/validation-message.component';
import { SharedValidators } from '../../shared/shared-validators';
import { Observable } from 'rxjs/Rx';
import { AutoUnsubscribe } from '../../../fw/decoractors/AutoUnsubscribe';
import {SharedService} from "../../shared/shared.service";
import {SettingsCashregService} from "./settings-cashreg.service";
import {AsyncValidatorWrapper} from "../../../fw/helpers/async-validator-wrapper";
import {DtoDiscount} from "./models/DtoDiscount";
import {DtoDiscountBaseItems} from "./models/DtoDiscountBaseItems";
import {SharedDataService} from "../../shared/shared-data.service";
import {DtoBranchUser} from "../../shared/models/DtoBranchUser";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";

@Component({
    selector: 'discount',
    template: require('./discount.component.html'),
    styles: [require('./discount.component.css')]
})
@AutoUnsubscribe()

export class DiscountComponent implements OnInit {
    @Input() dialog: DialogRef;
    @Input() id: number;
    @Input() copyFromId: number;
    @ViewChild('validationMessage', {static: false}) validationMessage: ValidationMessageComponent;
    @ViewChild('gridAvailability', {static: false}) gridAvailability: DynamicGridComponent;
    form: FormGroup;
    dtoObject: DtoDiscount;
    baseItems: DtoDiscountBaseItems;
    branches: DtoBranchUser[];
    activeItems: Array<{ text: string, value: boolean }> = [
        { text: "Ja", value: true },
        { text: "Nee", value: false }
    ];
    discountLabel: string;
    discountFormat: string;
    availabilityColumnDefinition: ColumnDefinition[] = [
        {
            key: 'hasAccess',
            label: 'Beschikbaar',
            type: 'boolean',
            width: '150px',
            enabled: true
        },
        {
            key: 'companyName',
            label: 'Filiaal',
            type: 'string',
            width: '*'
        }
    ];

    constructor(private fb: FormBuilder,
                private fs: FormService,
                private ds: SettingsCashregService,
                private ss: SharedService,
                private sds: SharedDataService) {
    }

    ngOnInit() {
        this.form = this.fb.group({
            description: ['', [SharedValidators.customRequired]],
            index: [null,[SharedValidators.customRequired]],
            isActive: null,
            discountAmount: null,
            grootboekNumber: null,
            departmentId: [null, [SharedValidators.customRequired]],
            articleSalesgroupId: null,
            articleSubSalesgroupId: null,
            treatmentSalesgroupId: null,
            treatmentSubSalesgroupId: null,
            cashregGroupId: null,
            cashregSubGroupId: null,
            btwGroupId: [null, [SharedValidators.customRequired]],
            discountKindId: [null, [SharedValidators.customRequired]],
            discountTypeId: [null, [SharedValidators.customRequired]],
            customerAdvice: null,
            variablePrice: null,
            employeeAdvice: null,
            barcode: null
        });

        this.form.valueChanges.subscribe(() =>
            {if (this.validationMessage) this.validationMessage.getFormValidationErrors();}
        );

        this.form.get('discountKindId').valueChanges.subscribe(newVal => {
            if (newVal == 1) {
                this.form.patchValue({ ['treatmentSalesgroupId']: null });
                this.form.patchValue({ ['treatmentSubSalesgroupId']: null });
            } else if (newVal == 2) {
                this.form.patchValue({ ['articleSalesgroupId']: null });
                this.form.patchValue({ ['articleSubSalesgroupId']: null });
            }
        });

        this.form.get('discountTypeId').valueChanges.subscribe(newVal => {
            if (newVal == 1) {
                this.discountLabel = 'Korting in €';
                this.discountFormat = 'n2';
            } else if (newVal == 2) {
                this.discountLabel = 'Korting in %';
                this.discountFormat = 'n2';
            } else if (newVal == 3) {
                this.discountLabel = 'Korting in punten';
                this.discountFormat = 'n2';
            } else if (newVal == 4) {
                this.discountLabel = 'Korting';
                this.discountFormat = 'n2';
            } else {
                this.discountLabel = 'Korting';
                this.discountFormat = 'n2';
            }
        });

        if (this.id > 0) {
            this.ds.getDiscountById(this.id)
                .subscribe(response => {
                    this.dtoObject = response;
                    this.getBaseItems();
                    this.fs.patchDtoToForm(this.dtoObject, this.form);
                });
        }
        else {
            this.ds.getDiscountNextIndex()
                .subscribe(res => {
                    this.dtoObject = {
                        id: 0,
                        index: res,
                        isActive: true,
                        discountAmount: 0,
                        variablePrice: true,
                        discountKindId: 2,
                        discountTypeId: 4,
                        availableInBranchesList: []
                    };
                    this.getBaseItems();

                    if (this.copyFromId > 0) {
                        this.ds.getDiscountById(this.copyFromId)
                            .subscribe(response => {
                                this.dtoObject.articleSalesgroupId = response.articleSalesgroupId;
                                this.dtoObject.articleSubSalesgroupId = response.articleSubSalesgroupId;
                                this.dtoObject.btwGroupId = response.btwGroupId;
                                this.dtoObject.cashregGroupId = response.cashregGroupId;
                                this.dtoObject.cashregSubGroupId = response.cashregSubGroupId;
                                this.dtoObject.customerAdvice = response.customerAdvice;
                                this.dtoObject.departmentId = response.departmentId;
                                this.dtoObject.description = response.description;
                                this.dtoObject.isActive = response.isActive;
                                this.dtoObject.treatmentSalesgroupId = response.treatmentSalesgroupId;
                                this.dtoObject.treatmentSubSalesgroupId = response.treatmentSubSalesgroupId;
                                this.dtoObject.discountAmount = response.discountAmount;
                                this.dtoObject.employeeAdvice = response.employeeAdvice;
                                this.dtoObject.variablePrice = response.variablePrice;
                                this.dtoObject.barcode = response.barcode;

                                for(let i = 0; i < response.availableInBranchesList.length; i++) {
                                    this.dtoObject.availableInBranchesList.push({
                                        id: response.availableInBranchesList[i].id,
                                        companyName: response.availableInBranchesList[i].companyName
                                    });
                                }

                                this.fs.patchDtoToForm(this.dtoObject, this.form);
                            });
                    }
                    else {
                        this.fs.patchDtoToForm(this.dtoObject, this.form);
                    }
                });
        }
    }

    getBaseItems() {
        this.ds.getDiscountBaseItems(false).subscribe(response => {
            this.baseItems = response;
            if (this.dtoObject && this.dtoObject.id == 0) {
                if (this.baseItems.departments.length == 1) {
                    this.dtoObject.departmentId = this.baseItems.departments[0].id;
                }
            }
        });
        this.sds.getBranches().subscribe(response => {
            this.branches = response;
            this.setBranchAvailability();

        });
    }

    getBranchAvailability() {
        let result = [];
        this.gridAvailability.getData().forEach(item => {
            if (item.hasAccess) {
                result.push({
                    id: item.id,
                    companyName: item.companyName
                });
            }
        });

        return result;
    }

    setBranchAvailability() {
        this.branches.forEach(item => {
            item.hasAccess = this.dtoObject.availableInBranchesList.some(x => x.id == item.id);
        });
        this.gridAvailability.showData(this.branches);
    }

    getArticleSubSalesgroups() {
        if (this.baseItems && this.form.get('articleSalesgroupId').value) {
            return this.baseItems.articleSalesgroups.find(x => x.id == this.form.get('articleSalesgroupId').value).articleSubSalesgroups;
        }
        return null;
    }

    getTreatmentSubSalesgroups() {
        if (this.baseItems && this.form.get('treatmentSalesgroupId').value) {
            return this.baseItems.treatmentSalesgroups.find(x => x.id == this.form.get('treatmentSalesgroupId').value).treatmentSubSalesgroups;
        }
        return null;
    }

    getCashregSubGroups() {
        if (this.baseItems && this.form.get('cashregGroupId').value) {
            return this.baseItems.cashregGroups.find(x => x.id == this.form.get('cashregGroupId').value).cashregSubGroups;
        }
        return null;
    }

    btnCancelClicked(event) {
        this.closeWindow(false);
    }

    btnSaveClicked(event) {
        this.validationMessage.validateForm();

        if (this.form.valid) {
            let result = this.fs.patchFormToDto(this.dtoObject, this.form);
            result.availableInBranchesList = this.getBranchAvailability();
            this.ds.saveDiscount(result)
                .subscribe(response => {
                    if (!response.hasError) {
                        this.ds.getArticleBaseItems(true);
                        this.closeWindow(true);
                    }
                    else {
                        this.ss.message(response.errorMessage);
                    }
                });
        }
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialog.dialog.instance.action.emit(result);
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-cashreg/discount.component.ts